import Icon from '@/shared/components/Icon/Icon';
import { IonButton, IonContent, IonItem, IonLabel, IonList, IonListHeader, useIonPopover } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { LanguageCode } from '@/i18n/config';
import { useLocale } from '@/shared/helpers/i18n';

import styles from './LanguageSelector.module.css';

type PopOverProps = {
  currentLanguage: string;
  onLanguageChange: (language: LanguageCode) => void;
};

const PopOver: React.FC<PopOverProps> = ({ currentLanguage, onLanguageChange }) => {
  const { t } = useTranslation();

  return (
    <IonContent>
      <IonList lines="none">
        <IonListHeader lines="full" className={styles.header}>
          {t('language_selector.language')}
        </IonListHeader>
        {Object.values(LanguageCode).map((languageCode) => (
          <IonItem button={true} detail={false} onClick={() => onLanguageChange(languageCode)}>
            <IonLabel>{t('language_selector', { context: languageCode })}</IonLabel>
            {currentLanguage === languageCode && (
              <Icon size="xmedium" src="assets/icons/checkmark-outline.svg" className={styles.icon} />
            )}
          </IonItem>
        ))}
      </IonList>
    </IonContent>
  );
};

const LanguageSelector: React.FC = () => {
  const { i18n, locale } = useLocale();

  const [present, dismiss] = useIonPopover(PopOver, {
    currentLanguage: locale,
    onLanguageChange: (nextLanguage: LanguageCode) => {
      dismiss();
      void i18n.changeLanguage(nextLanguage);
    }
  });

  return (
    <IonButton
      mode="ios"
      className={styles.menuButton}
      shape="round"
      fill="clear"
      onClick={(e: any) => present({ event: e })}
    >
      <Icon size="large" src="assets/icons/globe-outline.svg" slot="icon-only" color="tertiary-icon" />
    </IonButton>
  );
};

export default LanguageSelector;
